import GeneratedDataSourceInstanceStore from "./generated/GeneratedDataSourceInstanceStore"

class DataSourceInstanceStore extends GeneratedDataSourceInstanceStore {

}

export const dataSourceInstanceStore = new DataSourceInstanceStore()
